export default __webpack_public_path__ + "static/media/15-INT-(8-5).fcdd79f0.jpg";